
import React from 'react';
import { ListIcon, UploadIcon, ExportIcon, XMarkIcon, InformationCircleIcon } from '../../../components/Icons';
import { SpreadsheetFilters } from '../../../hooks/useAdminSpreadsheet';

interface OperationSpreadsheetHeaderProps {
    filters: SpreadsheetFilters;
    updateFilters: (f: Partial<SpreadsheetFilters>) => void;
    visibleCount: number;
    onOpenMassUpdate: () => void;
    onOpenExport: () => void;
    codeInput: string;
    setCodeInput: (v: string) => void;
    brpInput: string;
    setBrpInput: (v: string) => void;
}

export const OperationSpreadsheetHeader: React.FC<OperationSpreadsheetHeaderProps> = ({
    filters, updateFilters, visibleCount, onOpenMassUpdate, onOpenExport,
    codeInput, setCodeInput, brpInput, setBrpInput
}) => {
    const hasActiveFilters = filters.status.length > 0 || filters.owners.length > 0 || filters.brpCode || filters.propertyCode;

    return (
        <header className="px-8 py-6 border-b border-gray-100 flex flex-col gap-4 bg-gray-50/50">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                <div>
                    <h3 className="text-xl font-black text-gray-800 uppercase tracking-tight flex items-center gap-3">
                        <ListIcon className="w-6 h-6 text-sky-600" />
                        Gestión Masiva 183150
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">Perfil de Operación: Control de inventario inmobiliario.</p>
                </div>
                <div className="flex flex-wrap items-center gap-3">
                    <button 
                        onClick={onOpenMassUpdate}
                        className="flex items-center gap-2 px-5 py-2.5 bg-sky-600 text-white rounded-xl text-xs font-black uppercase tracking-widest shadow-lg hover:bg-sky-700 transition-all active:scale-95"
                    >
                        <UploadIcon className="w-4 h-4" />
                        Carga Masiva
                    </button>
                    <button 
                        onClick={onOpenExport}
                        className="flex items-center gap-2 px-5 py-2.5 bg-gray-900 text-white rounded-xl text-xs font-black uppercase tracking-widest shadow-lg hover:bg-black transition-all active:scale-95"
                    >
                        <ExportIcon className="w-4 h-4" />
                        Exportar
                    </button>
                    <span className="text-[10px] font-black text-sky-600 bg-sky-50 px-4 py-2 rounded-xl border border-sky-100 uppercase tracking-widest">
                        {visibleCount} inmuebles visibles
                    </span>
                    {hasActiveFilters && (
                        <button 
                            onClick={() => { 
                                updateFilters({ status: [], owners: [], brpCode: '', propertyCode: '' }); 
                                setBrpInput(''); 
                                setCodeInput(''); 
                            }}
                            className="text-[10px] font-black text-red-500 hover:text-red-700 uppercase flex items-center gap-1"
                        >
                            <XMarkIcon className="w-3 h-3"/> Limpiar Filtros
                        </button>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-2 px-4 py-2.5 bg-amber-50 border border-amber-200/80 rounded-xl text-xs text-amber-800 font-medium">
                <InformationCircleIcon className="w-4 h-4 text-amber-600 flex-shrink-0" />
                <span><strong>Aviso:</strong> Los cambios guardados se verán reflejados en un máximo de 5 minutos en las búsquedas y demás módulos.</span>
            </div>
        </header>
    );
};
